import React, { useState } from 'react';
import { Button } from '../ui/button';
import { Link } from 'react-router-dom';
import { CardContent } from '../ui/card';

const FeeTable = ({ filteredStudents, pendingFees, receivedFee }) => {
  const [visibleItems, setVisibleItems] = useState(10);

  const handleViewMore = () => {
    setVisibleItems(prev => prev + 10);
  };

  const displayedStudents = filteredStudents?.slice(0, visibleItems);

  return (
    <CardContent>
      <div className="overflow-x-auto">
        <table className="w-full border-collapse">
          <thead className="bg-[#F4F4F5]">
            <tr>
              <th className="px-4 py-3 text-left text-sm font-medium text-muted-foreground text-nowrap">
                #
              </th>
              <th className="px-4 py-3 text-left text-sm font-medium text-muted-foreground text-nowrap">
                Student Name
              </th>
              <th className="px-4 py-3 text-left text-sm font-medium text-muted-foreground text-nowrap">
                Batch Code
              </th>
              <th className="px-4 py-3 text-left text-sm font-medium text-muted-foreground">
                Course Name
              </th>
              <th className="px-4 py-3 text-left text-sm font-medium text-muted-foreground text-nowrap">
                Paid Amount
              </th>
              <th className="px-4 py-3 text-left text-sm font-medium text-muted-foreground text-nowrap">
                Pending Amount
              </th>
              <th className="px-4 py-3 text-left text-sm font-medium text-muted-foreground text-nowrap">
                Payable Amount
              </th>
              <th className="px-4 py-3 text-left text-sm font-medium text-muted-foreground text-nowrap">
                Fee Records
              </th>
            </tr>
          </thead>
          <tbody className="divide-y">
            {displayedStudents?.map((fee, index) => (
              <tr key={fee._id} className="hover:bg-muted">
                <td className="px-4 py-3 text-sm textforeground">
                  {index + 1}
                </td>
                <td className="px-4 py-3 text-sm textforeground">
                  {fee.name}
                </td>
                <td className="px-4 py-3 text-sm textforeground">
                  {fee.bCode}
                </td>
                <td className="px-4 py-3 text-sm textforeground">
                  {fee.course}
                </td>
                <td className="px-4 py-3 text-sm text-primary">
                  ₹{fee.paid?.toLocaleString()}
                </td>
                <td className="px-4 py-3 text-sm text-red-600">
                  ₹{(fee.payable - fee.paid).toLocaleString()}
                </td>
                <td className="px-4 py-3 text-sm textforeground">
                  ₹{fee.payable?.toLocaleString()}
                </td>
                <td className="px-4 py-3 text-sm">
                  <Link
                    to={`/feehistory/${fee.student}`}
                    className="text-blue-600 hover:underline"
                  >
                    View
                  </Link>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
        
        {filteredStudents?.length > visibleItems && (
          <div className="mt-4 flex justify-center">
            <Button
              variant="outline"
              onClick={handleViewMore}
              className="px-4 py-2"
            >
              View More
            </Button>
          </div>
        )}
      </div>

      <div className="mt-4 space-y-2">
        <div className="flex justify-between text-sm font-medium">
          <span>Total Pending Amount:</span>
          <span className="text-red-600">
            ₹{pendingFees?.toLocaleString()}
          </span>
        </div>
        <div className="flex justify-between text-sm font-medium">
          <span>Total Received Amount:</span>
          <span className="text-primary">
            ₹{receivedFee?.toLocaleString()}
          </span>
        </div>
      </div>
    </CardContent>
  );
};

export default FeeTable;